import { useEffect, useRef } from 'react';

const useJumpToSelectedGalleryPhoto = ({ selectedPhotoIndex, isOpen }) => {
  const galleryRef = useRef(null);

  useEffect(() => {
    if (isOpen && galleryRef.current && selectedPhotoIndex > 0) {
      const targetElement = galleryRef.current.children[selectedPhotoIndex];

      setTimeout(() => {
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 200);
    }
  }, [selectedPhotoIndex, isOpen]);

  return galleryRef;
};

export default useJumpToSelectedGalleryPhoto;
